import { FC } from 'react'
import styles from './Author.module.scss'
import Image from 'next/image'
import { AuthorProps as Props } from './types'

const Author: FC<Props> = ({ name, date, image }) => {
  return (
    <div className={styles['author-container']}>
      {image && (
        <div className={styles.avatar}>
          <Image src={image} layout="fill" objectFit="cover" alt={name} />
        </div>
      )}
      <div>
        <time className={styles.date}>{date}</time>
        <div className={styles.author}>{name}</div>
      </div>
    </div>
  )
}

export default Author
